import { render, staticRenderFns } from "./asset-attribute-select.vue?vue&type=template&id=1b944d4b&scoped=true&"
import script from "./asset-attribute-select.vue?vue&type=script&lang=js&"
export * from "./asset-attribute-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b944d4b",
  null
  
)

export default component.exports